export const MACHINE_BREAKDOWN_WIDTH_PERCENT = 50;
export const MACHINE_BREAKDOWN_WIDTH_OFFSET_PERCENT = 25;
export const BREAKDOWN_ROW_PADDING_EXPANDED_PX = 25;
